export interface IAccionistas {
  shareholder_intern_id: string
  shareholder_name: string
  company_type: string
  country: string
  companies_id: string[]
  companies_id_share_percentage: string[]
  companies: string
  profile: string
  source_official: string
  source_3: string
  spanish_profile: string
  english_profile: string
  portuguese_profile: string
}

export const Personas: IAccionistas[] = [
  {
    shareholder_intern_id: 'ACC01',
    shareholder_name: 'Martyn Element',
    company_type: '',
    country: '',
    companies_id: ['EMP01'],
    companies_id_share_percentage: ['EMP01:8,16'],
    companies: 'A.I.S. Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC02',
    shareholder_name: 'Andrew Neale',
    company_type: '',
    country: '',
    companies_id: ['EMP01'],
    companies_id_share_percentage: ['EMP01:1,17'],
    companies: 'A.I.S. Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC03',
    shareholder_name: 'Kiki Smith',
    company_type: '',
    country: '',
    companies_id: ['EMP01'],
    companies_id_share_percentage: ['EMP01:0,68'],
    companies: 'A.I.S. Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC04',
    shareholder_name: 'Muhammad Memon',
    company_type: '',
    country: '',
    companies_id: ['EMP01'],
    companies_id_share_percentage: ['EMP01:0,006'],
    companies: 'A.I.S. Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC05',
    shareholder_name: 'Marc Enright-Morin',
    company_type: '',
    country: '',
    companies_id: ['EMP01'],
    companies_id_share_percentage: ['EMP01:0'],
    companies: 'A.I.S. Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC06',
    shareholder_name: 'Marie Cupello Corporate Secretary & CFO',
    company_type: '',
    country: '',
    companies_id: ['EMP02'],
    companies_id_share_percentage: ['EMP02:0'],
    companies: 'Advance Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC07',
    shareholder_name: 'William Atkinson Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP02'],
    companies_id_share_percentage: ['EMP02:0'],
    companies: 'Advance Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC08',
    shareholder_name: 'Vanguard Group Inc.',
    company_type: '',
    country: '',
    companies_id: [
      'EMP03',
      'EMP26',
      'EMP29',
      'EMP59',
      'EMP65',
      'EMP74',
      'EMP75',
      'EMP81',
    ],
    companies_id_share_percentage: [
      'EMP03:12,41',
      'EMP06:15,22',
      'EMP26:1,21',
      'EMP29:1,03',
      'EMP59:4,1',
      'EMP65:4,84',
      'EMP74:0,29',
      'EMP75:2,76',
      'EMP81:1,19',
    ],
    companies:
      'Albemarle Corporation,Eramet S.A.,Ganfeng Lithium Group Co. Ltd. ,POSCO Holdings Inc.,Rio Tinto Group,Tibet Summit Resources Co. Ltd.,Toyota Tsusho Corporation (TTC),Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC09',
    shareholder_name: 'BlackRock Inc.',
    company_type: '',
    country: '',
    companies_id: [
      'EMP03',
      'EMP26',
      'EMP29',
      'EMP59',
      'EMP65',
      'EMP67',
      'EMP71',
      'EMP75',
      'EMP81',
    ],
    companies_id_share_percentage: [
      'EMP03:8,901',
      'EMP26:0,77',
      'EMP29:1,11',
      'EMP59:5,9',
      'EMP65:7,35',
      'EMP67:1,7',
      'EMP71:3,34',
      'EMP75:2,76',
      'EMP81:2,11',
    ],
    companies:
      'Albemarle Corporation,Eramet S.A.,Ganfeng Lithium Group Co. Ltd. ,POSCO Holdings Inc.,Rio Tinto Group,Sigma Lithium Corporation,Stellantis N.V.,Toyota Tsusho Corporation (TTC),Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC10',
    shareholder_name: 'State Street Global Advisors Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP65'],
    companies_id_share_percentage: ['EMP03:5,55', 'EMP65:3,32'],
    companies: 'Albemarle Corporation,Rio Tinto Group',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC11',
    shareholder_name: 'PRIMECAP Management Co.',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:2,85'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC12',
    shareholder_name: 'Geode Capital Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:2,38'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC13',
    shareholder_name: 'Franklin Resources Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:2,2'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC14',
    shareholder_name: 'Baillie Gifford & Co.',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP29'],
    companies_id_share_percentage: ['EMP03:1,82', 'EMP29:3'],
    companies: 'Albemarle Corporation,Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC15',
    shareholder_name: 'ProShare Advisors LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:1,69'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC16',
    shareholder_name: 'Invesco Capital Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP40'],
    companies_id_share_percentage: ['EMP03:1,5', 'EMP40:1,03'],
    companies: 'Albemarle Corporation,Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC17',
    shareholder_name: 'Earnest Partners LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:1,22'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC18',
    shareholder_name: 'UBS Asset Management AG',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP65', 'EMP81'],
    companies_id_share_percentage: ['EMP03:2,72', 'EMP65:1,44', 'EMP81:1,26'],
    companies:
      'Albemarle Corporation,Rio Tinto Group,Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC19',
    shareholder_name: 'Mirae Asset Global Investments Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP40'],
    companies_id_share_percentage: ['EMP03:1,02', 'EMP40:2,6'],
    companies: 'Albemarle Corporation,Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC20',
    shareholder_name: 'Columbia Management Investment Advisers LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:0,74'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC21',
    shareholder_name: 'Dimensional Fund Advisors LP',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP59'],
    companies_id_share_percentage: ['EMP03:1,02', 'EMP59:0,74'],
    companies: 'Albemarle Corporation,POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC22',
    shareholder_name: 'Pictet Asset Management Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP79'],
    companies_id_share_percentage: ['EMP03:1,01', 'EMP79:0,76'],
    companies: 'Albemarle Corporation,Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC23',
    shareholder_name: 'Bank of America Corp.',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP40'],
    companies_id_share_percentage: ['EMP03:0,82', 'EMP40:?'],
    companies: 'Albemarle Corporation,Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC24',
    shareholder_name: 'Northern Trust Global Investments',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:1,1'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC25',
    shareholder_name: 'Charles Schwab Investment Management Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:0,89'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC26',
    shareholder_name: 'Manning & Napier Advisors LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:0,85'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC27',
    shareholder_name: 'Eaton Vance Management',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:1,02'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC28',
    shareholder_name: 'Morgan Stanley',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:0,77'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC29',
    shareholder_name: 'Global X Management Company LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:0,98'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC30',
    shareholder_name: 'Millennium Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP03', 'EMP40'],
    companies_id_share_percentage: ['EMP03:0,82', 'EMP40:?'],
    companies: 'Albemarle Corporation,Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC31',
    shareholder_name: 'RobecoSAM AG',
    company_type: '',
    country: '',
    companies_id: ['EMP03'],
    companies_id_share_percentage: ['EMP03:0,7'],
    companies: 'Albemarle Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC32',
    shareholder_name: 'Hargreaves Landsdown Asset Mgt',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:24,2'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC33',
    shareholder_name: 'Interactive Investor',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:11,8'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC34',
    shareholder_name: 'Halifax Share Dealing',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:6,11'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC35',
    shareholder_name: 'Windfield Metals Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:5,02'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC36',
    shareholder_name: 'AJ Bell Securietes',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:3,45'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC37',
    shareholder_name: 'Glimore Capital',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:3,44'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC38',
    shareholder_name: 'Barclays Wealth',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:3,19'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC39',
    shareholder_name: 'IG Markets',
    company_type: '',
    country: '',
    companies_id: ['EMP04'],
    companies_id_share_percentage: ['EMP04:3,11'],
    companies: 'Alien Metals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC40',
    shareholder_name: 'Global X Management Co. LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:4,98'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC41',
    shareholder_name: 'Andrew Bowering',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:3,36'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC42',
    shareholder_name: 'Laurence Stefan',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:3,02'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC43',
    shareholder_name: 'European Capital Partners (Luxembourg) SA',
    company_type: '',
    country: '',
    companies_id: ['EMP05', 'EMP41'],
    companies_id_share_percentage: ['EMP05:0,78', 'EMP412:0,72'],
    companies: 'American Lithium Corp.,Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC44',
    shareholder_name: 'BayernInvest Kapitalverwaltungsgesellschaft mbH',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:0,7'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC45',
    shareholder_name: "Ted O'Connor",
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:0,31'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC46',
    shareholder_name: 'Ben Binninger',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:0,25'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC47',
    shareholder_name: 'Alexander Tsakumis',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:0,11'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC48',
    shareholder_name: 'Claudia Tornquist',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP06:0,09'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC49',
    shareholder_name: 'Paul Charlish',
    company_type: '',
    country: '',
    companies_id: ['EMP05'],
    companies_id_share_percentage: ['EMP05:0,06'],
    companies: 'American Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC50',
    shareholder_name:
      'Robert Nicholas Pete Horsley CEO President Secretary Director',
    company_type: '',
    country: '',
    companies_id: ['EMP06'],
    companies_id_share_percentage: ['EMP06:5,71'],
    companies: 'American Salars Lithium Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC51',
    shareholder_name: 'Vanguard Mining Corp.',
    company_type: '',
    country: '',
    companies_id: ['EMP06'],
    companies_id_share_percentage: ['EMP06:15,22'],
    companies: 'American Salars Lithium Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC52',
    shareholder_name: 'Recharge Resources Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP06'],
    companies_id_share_percentage: ['EMP06:?'],
    companies: 'American Salars Lithium Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC53',
    shareholder_name: 'Michael W. Scott',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:17,89'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC54',
    shareholder_name: 'Jack Yetiv',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:14,78'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC55',
    shareholder_name: 'Joseph Nicola Grosso Executive Chairman',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:2,96'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC56',
    shareholder_name: 'Nikolaos Cacos President CEO & Director',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:1,01'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC57',
    shareholder_name: 'Vinland Holdings Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:0,57'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC58',
    shareholder_name: 'Connie Norman Corporate Secretary',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:0,26'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC59',
    shareholder_name: 'John Buckle Gammon Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:0,15'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC60',
    shareholder_name: 'David Andrew Terry Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP07'],
    companies_id_share_percentage: ['EMP07:0,03'],
    companies: 'Argentina Lithium & Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC61',
    shareholder_name: 'Citicorp Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:3,74'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC62',
    shareholder_name: 'Amperex Technology Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:3,54'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC63',
    shareholder_name: 'Mr Kerko Peter Zuvela <Jakkz Discretionary A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:3,25'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC64',
    shareholder_name: 'Dihna Nada Zuvela <DNZ Discretionary A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:2,22'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC65',
    shareholder_name: 'Mr Steven Marin Zuvela <Taez A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:1,78'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC66',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd <Clearstream>',
    company_type: '',
    country: '',
    companies_id: ['EMP08', 'EMP11', 'EMP36'],
    companies_id_share_percentage: ['EMP08:1,6', 'EMP11:3,6', 'EMP36:0,92'],
    companies:
      'Argosy Minerals Limited,Australian Mines Limited,Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC67',
    shareholder_name: 'Mr Weimin Chein',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:1,51'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC68',
    shareholder_name: 'Mrs Xiaoli Cai',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:1,31'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC69',
    shareholder_name: 'OSF Nominees Pty Ltd <Frederickson Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:1,16'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC70',
    shareholder_name: 'Finclear Services Pty Ltd <Superhero Securities A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08', 'EMP55', 'EMP80'],
    companies_id_share_percentage: ['EMP08:1,06', 'EMP55:1,37', 'EMP80:0,77'],
    companies:
      'Argosy Minerals Limited,OzAurum Resources Limited,XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC71',
    shareholder_name: 'JP Morgan Nominees Austrlia Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,95'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC72',
    shareholder_name: 'Oliver Scarlett Resources Pte Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,82'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC73',
    shareholder_name: 'Mr Jerko Peter Zuvela',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,76'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC74',
    shareholder_name: 'Mrs Anita Dragana Zuvela',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,76'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC75',
    shareholder_name:
      'Stonnington Investments Pty Ltd <The Stonnington Unit A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,72'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC76',
    shareholder_name: 'Mr Dion Tadic',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,62'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC77',
    shareholder_name: 'Mr Steven Camarda <SC A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,57'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC78',
    shareholder_name:
      'Mr Andrew James Rushworth & Mrs Judith Kay Rushworth <A&J Rusworth Super A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP08'],
    companies_id_share_percentage: ['EMP08:0,57'],
    companies: 'Argosy Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC79',
    shareholder_name: 'Nader Vatanchi',
    company_type: '',
    country: '',
    companies_id: ['EMP09'],
    companies_id_share_percentage: ['EMP09:0,39'],
    companies: 'Armory Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC80',
    shareholder_name: 'Lawrence Hay',
    company_type: '',
    country: '',
    companies_id: ['EMP09'],
    companies_id_share_percentage: ['EMP09:0,3'],
    companies: 'Armory Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC81',
    shareholder_name: 'Ashish Misquith',
    company_type: '',
    country: '',
    companies_id: ['EMP09'],
    companies_id_share_percentage: ['EMP09:0,05'],
    companies: 'Armory Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC82',
    shareholder_name: 'Aaron Wong',
    company_type: '',
    country: '',
    companies_id: ['EMP09'],
    companies_id_share_percentage: ['EMP09:0'],
    companies: 'Armory Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC83',
    shareholder_name: 'Mark Fogassa',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:29,2'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC84',
    shareholder_name: 'Roger Noriega',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:2,3'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC85',
    shareholder_name: 'Igor Tkachenko',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:1,2'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC86',
    shareholder_name: 'Stephen Petersen',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:0,3'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC87',
    shareholder_name: 'Rodrigo Menck',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:0,1'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC88',
    shareholder_name: 'Tiago Miranda',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:0'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC89',
    shareholder_name: 'Gustavo Aguilar',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:?'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC90',
    shareholder_name: 'Brian Talbot',
    company_type: '',
    country: '',
    companies_id: ['EMP10'],
    companies_id_share_percentage: ['EMP10:?'],
    companies: 'Atlas Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC91',
    shareholder_name: 'Citicorp Nominees Pty Limited',
    company_type: '',
    country: '',
    companies_id: [
      'EMP11',
      'EMP54',
      'EMP55',
      'EMP36',
      'EMP62',
      'EMP70',
      'EMP80',
    ],
    companies_id_share_percentage: [
      'EMP11:2,68',
      'EMP54:3,48',
      'EMP55:0,89',
      'EMP36:9,19',
      'EMP62:1,93',
      'EMP70:1,93',
      'EMP80:1,37',
    ],
    companies:
      'Australian Mines Limited,Oceana Lithium Limited,OzAurum Resources Limited,Pilbara Minerals Ltd (PLS),Pursuit Minerals Limited,Solis Minerals Ltd.,XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC92',
    shareholder_name: 'Yonglu Yu',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:2,15'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC93',
    shareholder_name: 'Rafael Viola Mottin',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:2,15'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC94',
    shareholder_name: 'Mr Yonglu Yu',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:1,87'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC95',
    shareholder_name:
      'Mrs Antonia Rosaria Galati-Rando & Mr Antonio Galati-Rando',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:1,57'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC96',
    shareholder_name: 'Whale Watch Holdings Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:1,43'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC97',
    shareholder_name: 'Andrew Luke Nesbitt',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:1,43'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC98',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd <IB AU Noms Retailclient>',
    company_type: '',
    country: '',
    companies_id: ['EMP11', 'EMP55', 'EMP36', 'EMP70', 'EMP78'],
    companies_id_share_percentage: [
      'EMP11:1,25',
      'EMP55:3,3',
      'EMP36:0,54',
      'EMP70:1,92',
      'EMP78:1,27',
    ],
    companies:
      'Australian Mines Limited,OzAurum Resources Limited,Pilbara Minerals Ltd (PLS),Solis Minerals Ltd.,Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC99',
    shareholder_name: 'Mr Rafael Viola Mottin',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:1,07'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC100',
    shareholder_name: 'Mr Malcolm Clark Anderson',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:088'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC101',
    shareholder_name: 'Mr Gregory Giannopoulus',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,87'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC102',
    shareholder_name: 'K&D Trading Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,86'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC103',
    shareholder_name: 'Mr Antanas Guoga',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,81'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC104',
    shareholder_name: 'Mr Poh Seng Tan',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,79'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC105',
    shareholder_name: 'Michael Elias',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,72'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC106',
    shareholder_name: 'Dominic Marinelli',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,72'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC107',
    shareholder_name: 'Michael Ramsden',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,72'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC108',
    shareholder_name: 'Mr Dwayne Kerry Daniels',
    company_type: '',
    country: '',
    companies_id: ['EMP11'],
    companies_id_share_percentage: ['EMP11:0,7'],
    companies: 'Australian Mines Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC109',
    shareholder_name: 'Hargreaves Lansdown (Nominees) Limited (15942)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:12,83'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC110',
    shareholder_name: 'Hargreaves Lansdown (Nominees) Limited (VRA)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:8,91'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC111',
    shareholder_name:
      'Interactive Investor Services Nominees Limited (SMKTISAS)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:8,85'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC112',
    shareholder_name: 'Lynchwood Nominees Limited (2006420)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:7,31'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC113',
    shareholder_name:
      'Interactive Investor Services Nominees Limited (SMKTNOMS)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:5,25'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC114',
    shareholder_name: 'Hargreaves Lansdown (Nominees) Limited (HLNOM)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:5,04'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC115',
    shareholder_name: 'Barclays Direct Investing Nominees Limited (CLIENT1)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:4,87'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC116',
    shareholder_name: 'HSDL Nominees Limited (MAXI)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:4,82'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC117',
    shareholder_name: 'Redmayne (Nominees) Limited (PENSUN)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:4,36'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC118',
    shareholder_name: 'Vidacos Nominees Limited (IGUKCLT)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:3,77'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC119',
    shareholder_name: 'Lawshare Nominees Limited (SIPP)',
    company_type: '',
    country: '',
    companies_id: ['EMP15'],
    companies_id_share_percentage: ['EMP15:3,24'],
    companies: 'Cadence Minerals Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC120',
    shareholder_name: 'Christian Alexander Hirtz Naundorff',
    company_type: '',
    country: '',
    companies_id: ['EMP16', 'EMP32', 'EMP50', 'EMP56', 'EMP66', 'EMP84'],
    companies_id_share_percentage: [
      'EMP16:33',
      'EMP32:33',
      'EMP50:33',
      'EMP56:33',
      'EMP66:33',
      'EMP84:33,3',
    ],
    companies:
      'Chaco Lithium SA,Guarani Lithium SA,Minera Atenea SA,Paraguay Lithium SA,Roca Lithium SA,Valquiria Exploration SA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC121',
    shareholder_name: 'Wilmar Bartel Hildebrandt',
    company_type: '',
    country: '',
    companies_id: ['EMP16', 'EMP32', 'EMP50', 'EMP56', 'EMP66', 'EMP84'],
    companies_id_share_percentage: [
      'EMP16:33',
      'EMP32:33',
      'EMP50:33',
      'EMP56:33',
      'EMP66:33',
      'EMP84:33,3',
    ],
    companies:
      'Chaco Lithium SA,Guarani Lithium SA,Minera Atenea SA,Paraguay Lithium SA,Roca Lithium SA,Valquiria Exploration SA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC122',
    shareholder_name: 'Fernando Javier Díaz Mallorquín',
    company_type: '',
    country: '',
    companies_id: ['EMP16', 'EMP32', 'EMP50', 'EMP56', 'EMP66', 'EMP84'],
    companies_id_share_percentage: [
      'EMP16:17,5',
      'EMP32:16,5',
      'EMP50:17,5',
      'EMP56:17,5',
      'EMP66:17,5',
      'EMP84:17,5',
    ],
    companies:
      'Chaco Lithium SA,Guarani Lithium SA,Minera Atenea SA,Paraguay Lithium SA,Roca Lithium SA,Valquiria Exploration SA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC123',
    shareholder_name: 'Rodrigo Díaz Mallorquín',
    company_type: '',
    country: '',
    companies_id: ['EMP16', 'EMP32', 'EMP50', 'EMP56', 'EMP66', 'EMP84'],
    companies_id_share_percentage: [
      'EMP16:15,5',
      'EMP32:16,5',
      'EMP50:15,5',
      'EMP56:16,5',
      'EMP66:15,5',
      'EMP84:15,5',
    ],
    companies:
      'Chaco Lithium SA,Guarani Lithium SA,Minera Atenea SA,Paraguay Lithium SA,Roca Lithium SA,Valquiria Exploration SA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC124',
    shareholder_name: 'Athos',
    company_type: '',
    country: '',
    companies_id: ['EMP18'],
    companies_id_share_percentage: ['EMP18:22,9'],
    companies: 'CleanTech Lithium Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC125',
    shareholder_name: 'Metales Uno',
    company_type: '',
    country: '',
    companies_id: ['EMP18'],
    companies_id_share_percentage: ['EMP18:10'],
    companies: 'CleanTech Lithium Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC126',
    shareholder_name: 'Regal',
    company_type: '',
    country: '',
    companies_id: ['EMP18'],
    companies_id_share_percentage: ['EMP18:8'],
    companies: 'CleanTech Lithium Plc',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC127',
    shareholder_name: 'Estado de Chile',
    company_type: '',
    country: '',
    companies_id: ['EMP22', 'EMP104'],
    companies_id_share_percentage: ['EMP22:100', 'EMP104:100'],
    companies:
      'Corporación Nacional del Cobre de Chile (Codelco),Empresa Nacional de Minería (ENAMI)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC128',
    shareholder_name: 'Provincia de La Rioja',
    company_type: '',
    country: '',
    companies_id: ['EMP87'],
    companies_id_share_percentage: ['EMP87:100'],
    companies: 'Energía y Minerales S.E. (EMSE)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC129',
    shareholder_name: 'Leslie Hobkirk',
    company_type: '',
    country: '',
    companies_id: ['EMP25'],
    companies_id_share_percentage: ['EMP25:12,95'],
    companies: 'Eon Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC130',
    shareholder_name:
      'Fernando Erik Villarroel Alcoceer CEO, President & Director',
    company_type: '',
    country: '',
    companies_id: ['EMP25'],
    companies_id_share_percentage: ['EMP25:2,88'],
    companies: 'Eon Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC131',
    shareholder_name: 'Cherry Consulting Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP25'],
    companies_id_share_percentage: ['EMP25:2,22'],
    companies: 'Eon Lithium Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC132',
    shareholder_name: 'The French Republic',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:27,16'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC133',
    shareholder_name: 'Bpifrance Participations SA',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:27,16'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC134',
    shareholder_name:
      'Société Territoriale Calédonienne de Participation Industrielle',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:4,08'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC135',
    shareholder_name: 'Van Eck Associates Corporation',
    company_type: '',
    country: '',
    companies_id: ['EMP26', 'EMP29', 'EMP67', 'EMP81'],
    companies_id_share_percentage: [
      'EMP26:3,67',
      'EMP29:0,76',
      'EMP67:4,14',
      'EMP81:1,1',
    ],
    companies:
      'Eramet S.A.,Ganfeng Lithium Group Co. Ltd. ,Sigma Lithium Corporation,Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC136',
    shareholder_name: 'Eramet SA, ESOP',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:1,57'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC137',
    shareholder_name: 'Kopernik Global Investors, LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:1,18'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC138',
    shareholder_name: 'T.Rowe Price Group, Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:0,89'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC139',
    shareholder_name: 'Groupe Cdc',
    company_type: '',
    country: '',
    companies_id: ['EMP26'],
    companies_id_share_percentage: ['EMP26:0,69'],
    companies: 'Eramet S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC140',
    shareholder_name: 'Clean Elements Fund (held in escrow)',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:8,59'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC141',
    shareholder_name: 'Citicorp Nominees Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP28', 'EMP30', 'EMP35'],
    companies_id_share_percentage: [
      'EMP28:7,16',
      'EMP30:2,85',
      'EMP35:11,47',
    ],
    companies: 'Galan Lithium Limited,Gold Mountain Limited,Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC142',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd (IB AU Noms Retail Client)',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:7,07'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC143',
    shareholder_name: 'HSBC Custody Niminees (Australia) Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:6,21'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC144',
    shareholder_name: 'BNP Paribas Noms Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP28', 'EMP30', 'EMP36', 'EMP80'],
    companies_id_share_percentage: [
      'EMP28:6,06',
      'EMP30:22,92',
      'EMP36:1,87',
      'EMP80:3,69',
    ],
    companies:
      'Galan Lithium Limited,Gold Mountain Limited,Pilbara Minerals Ltd (PLS),XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC145',
    shareholder_name: 'Latam Resources Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:4,05'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC146',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd (Clearstream)',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:3,01'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC147',
    shareholder_name: 'HSBC Custody Niminees (Australia) Limited - A/c2',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:2,73'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC148',
    shareholder_name: 'Compania Constructora Y Servicios Excon SA',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:2,67'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC149',
    shareholder_name:
      'Annandale Street Holdings Pty Ltd (Annadale Street Holding A/c)',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:1,63'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC150',
    shareholder_name: 'Havelock Mining Investment Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:1,6'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC151',
    shareholder_name: 'Mr Zhaoyang Liu',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:1,39'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC152',
    shareholder_name: 'Juan Pablo Vargas de la Vega',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:1,17'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC153',
    shareholder_name: 'Ouyang b&Hu Pty Ltd (Ouuyang Family A/c)',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:0,8'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC154',
    shareholder_name: 'Mr Terry Gardiner',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:0,77'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC155',
    shareholder_name: 'Mrs Kelly Allen',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:0,66'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC156',
    shareholder_name: 'HSBC Custody Nominees (Australia) Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP28', 'EMP30', 'EMP35', 'EMP36', 'EMP72', 'EMP80'],
    companies_id_share_percentage: [
      'EMP28:065',
      'EMP30:18,34',
      'EMP35:4,55',
      'EMP36:20,1',
      'EMP72:1,21',
      'EMP80:1,81',
    ],
    companies:
      'Galan Lithium Limited,Gold Mountain Limited,Lake Resources NL,Pilbara Minerals Ltd (PLS),Summit Minerals Limited,XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC157',
    shareholder_name: 'Mr Bradley William Smith',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:0,6'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC158',
    shareholder_name: 'Mr Yizhong Zhang',
    company_type: '',
    country: '',
    companies_id: ['EMP28'],
    companies_id_share_percentage: ['EMP28:0,59'],
    companies: 'Galan Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC159',
    shareholder_name: 'JP Morgan Nominees Australia Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP28', 'EMP35'],
    companies_id_share_percentage: ['EMP28:0,54', 'EMP35:2,66'],
    companies: 'Galan Lithium Limited,Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC160',
    shareholder_name: 'Huatai-PineBridge Fund Management Co., Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP29'],
    companies_id_share_percentage: ['EMP29:0,95'],
    companies: 'Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC161',
    shareholder_name: 'E Fund Management Co., Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP29'],
    companies_id_share_percentage: ['EMP29:0,66'],
    companies: 'Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC162',
    shareholder_name: 'UBS SDIC Fund Management Co., Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP29'],
    companies_id_share_percentage: ['EMP29:0,56'],
    companies: 'Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC163',
    shareholder_name: 'JP Morgan Asset Management',
    company_type: '',
    country: '',
    companies_id: ['EMP29'],
    companies_id_share_percentage: ['EMP29:0,49'],
    companies: 'Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC164',
    shareholder_name: 'Shenzhen Jinhui Rongsheng Wealth Management Co., Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP29'],
    companies_id_share_percentage: ['EMP29:0,46'],
    companies: 'Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC165',
    shareholder_name:
      'Jinhui Rongsheng Rongcheng Xingsheng No.1 Private Security',
    company_type: '',
    country: '',
    companies_id: ['EMP29'],
    companies_id_share_percentage: ['EMP29:0,46'],
    companies: 'Ganfeng Lithium Group Co. Ltd. ',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC166',
    shareholder_name: 'Gibaud-Lith',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:43,1'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC167',
    shareholder_name: 'Opal Invest',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:15,7'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC168',
    shareholder_name: 'Lith-Tech Ventures gmbh',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:8,4'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC169',
    shareholder_name: 'Philippe Degremont',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:8'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC170',
    shareholder_name: 'Alfardan International LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:4,5'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC171',
    shareholder_name: 'Didier Muschalle',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:4,5'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC172',
    shareholder_name: 'Jean-Georges Malcor',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:2,7'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC173',
    shareholder_name: 'Hathi Invest',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:2,7'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC174',
    shareholder_name: 'Alex Demirdjian',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:2,2'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC175',
    shareholder_name: 'Bernard Gillery',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:1,8'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC176',
    shareholder_name: 'Guillaume Gros',
    company_type: '',
    country: '',
    companies_id: ['EMP94'],
    companies_id_share_percentage: ['EMP94:1,8'],
    companies: 'Geolith',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC177',
    shareholder_name: 'Pellegri International Corp',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:6,02'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC178',
    shareholder_name: 'Mr David Andrew Evans',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:2,45'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC179',
    shareholder_name: 'Mars Mines Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:2,07'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC180',
    shareholder_name: 'Kadoo Pty Limited <B&D Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:1,54'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC181',
    shareholder_name: 'Mr Chips Super Pty Ltd <Mr Chips SF A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:1,44'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC182',
    shareholder_name: 'Mr Sherman Alvo Francis Picardo',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:1,2'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC183',
    shareholder_name: '10 Bolivianos Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP30', 'EMP60'],
    companies_id_share_percentage: ['EMP30:1,18', 'EMP60:1,45'],
    companies: 'Gold Mountain Limited,Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC184',
    shareholder_name: 'Mr David Evans',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,98'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC185',
    shareholder_name: 'Rigi Investments Pty Limited <The Cape A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,88'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC186',
    shareholder_name: "BNP Paribas Nominees Pty ltd <UOBKH R'MIERS>",
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30: 0,79'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC187',
    shareholder_name: 'Dimensional Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,75'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC188',
    shareholder_name: 'L1 Capital Global Opportunitie Fund',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,74'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC189',
    shareholder_name: 'Ram Systems Pty Limited >Reardon Family Super A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,65'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC190',
    shareholder_name: 'Dov Greenberg',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,59'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC191',
    shareholder_name: 'Grace Matt Pty Ltd <Dr Thien Nguyen PL S/F A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,56'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC192',
    shareholder_name: 'The Summit Hotel Bondi Beach Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP30'],
    companies_id_share_percentage: ['EMP30:0,46'],
    companies: 'Gold Mountain Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC193',
    shareholder_name: 'Celtic Finance Corp Pty Ltd <Income A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:12,28'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC194',
    shareholder_name: 'CPS Capital No 5 Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:10,51'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC195',
    shareholder_name: 'Plutus Ventures Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82', 'EMP72'],
    companies_id_share_percentage: ['EMP82:14,43', 'EMP72:1,51'],
    companies: 'Great Northern Minerals Limited (GNM),Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC196',
    shareholder_name: 'Celtic Capital Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:9,14'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC197',
    shareholder_name: 'Celtic Finance Corp Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82', 'EMP62'],
    companies_id_share_percentage: ['EMP82:7,42', 'EMP62:1,35'],
    companies: 'Great Northern Minerals Limited (GNM),Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC198',
    shareholder_name: 'Sabsien Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:3,75'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC199',
    shareholder_name: 'Pearl Glow Investments Pty Ltd <The Pearglow A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:3,65'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC200',
    shareholder_name: 'Mr Keith Della-Vedova <Kovar SSAS A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:2,25'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC201',
    shareholder_name: 'Lake Springs Pty Ltd <The Lake Spings SF A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:2,08'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC202',
    shareholder_name: 'Nemo Resources Inc',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:1,19'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC203',
    shareholder_name: 'Mr John Casey Power',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:1,19'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC204',
    shareholder_name: 'Hensin SMSF Pty Ltd <Hensin SMSF A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:1,04'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC205',
    shareholder_name: 'First One Realty Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,89'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC206',
    shareholder_name: 'Reeve Ventures Pty ltd <The Vega A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,73'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC207',
    shareholder_name: 'Spring Tide Pension Pty Ltd <Spring Tide Pension A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,73'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC208',
    shareholder_name: 'Celtic Capital Pty Ltd <Celtic Capital NO 2 A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,58'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC209',
    shareholder_name: 'CPS Capital Group Pty Ltd <The Fidelty A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,57'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC210',
    shareholder_name: 'Shriver Nominees Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,51'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC211',
    shareholder_name: 'Ms Nicole Gallin + Mr Kyle Haynes <GH Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,51'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC212',
    shareholder_name: 'Riqueza Ventures Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP82'],
    companies_id_share_percentage: ['EMP82:0,51'],
    companies: 'Great Northern Minerals Limited (GNM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC213',
    shareholder_name: 'Gentoo Media Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:9,07'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC214',
    shareholder_name: 'Rookharp Capital Pty Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:8,25'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC215',
    shareholder_name: 'Wesley Jon Maas',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:5,05'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC216',
    shareholder_name: 'Leesa Jan Rooke',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:4,25'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC217',
    shareholder_name: 'David Michael Rooke',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:4,25'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC218',
    shareholder_name: 'Colourworks Australia Pty. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:2,48'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC219',
    shareholder_name: 'Peter Stanley Wright Executive Director',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:2,07'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC220',
    shareholder_name: 'CPS Control Systems Pty Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:1,8'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC221',
    shareholder_name: 'Richard Stacy Anthon Non Executive Chairman',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:1,8'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC222',
    shareholder_name: 'K R Khatri (Dental) Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:1,31'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC223',
    shareholder_name: 'Finn Air Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:1,04'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC224',
    shareholder_name: 'Jeffrey Royce Marvin Non-Executive Director',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,94'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC225',
    shareholder_name: 'Neil Francis Stuart',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,93'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC226',
    shareholder_name: 'David Joseph Mason',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,91'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC227',
    shareholder_name: 'Row Boat Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,89'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC228',
    shareholder_name: 'R & A Super Co Pty. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,85'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC229',
    shareholder_name: 'Simon William Tritton',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,83'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC230',
    shareholder_name: 'Oceans74 Smsf Pty. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,81'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC231',
    shareholder_name: 'Carol Ann Purdie',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,78'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC232',
    shareholder_name: 'Phillip Alexander Purdie',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,78'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC233',
    shareholder_name: 'James Stuart Brown Non Executive Director',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,69'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC234',
    shareholder_name: 'Renee Jan Dunn',
    company_type: '',
    country: '',
    companies_id: ['EMP31'],
    companies_id_share_percentage: ['EMP31:0,53'],
    companies: 'Greenwing Resources Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC235',
    shareholder_name: 'Contemporary Amperex Technology Co. Ltd. (CATL)',
    company_type: '',
    country: '',
    companies_id: ['EMP90'],
    companies_id_share_percentage: ['EMP90:?'],
    companies: 'Hong Kong CBC Investment Limited (CBC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC236',
    shareholder_name: 'Guangdong Brunp Recycling Technology Co. Ltd. (Brunp)',
    company_type: '',
    country: '',
    companies_id: ['EMP90'],
    companies_id_share_percentage: ['EMP90:?'],
    companies: 'Hong Kong CBC Investment Limited (CBC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC237',
    shareholder_name: 'CMOC',
    company_type: '',
    country: '',
    companies_id: ['EMP90'],
    companies_id_share_percentage: ['EMP90:?'],
    companies: 'Hong Kong CBC Investment Limited (CBC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC238',
    shareholder_name: 'Integra Lithium Resources LLP',
    company_type: '',
    country: '',
    companies_id: ['EMP33'],
    companies_id_share_percentage: ['EMP33:95'],
    companies: 'Integra Lithium S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC239',
    shareholder_name: 'Provincia de Jujuy',
    company_type: '',
    country: '',
    companies_id: ['EMP34'],
    companies_id_share_percentage: ['EMP34:100'],
    companies: 'Jujuy Energía y Minería Sociedad del Estado (JEMSE)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC240',
    shareholder_name: 'Parque Eólico Arauco S.A.P.E.M.',
    company_type: '',
    country: '',
    companies_id: ['EMP88'],
    companies_id_share_percentage: ['EMP88:?'],
    companies: 'Kallpa S.A.P.E.M.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC241',
    shareholder_name: 'Energía Riojana S.A. (ERSA)',
    company_type: '',
    country: '',
    companies_id: ['EMP88'],
    companies_id_share_percentage: ['EMP88:?'],
    companies: 'Kallpa S.A.P.E.M.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC242',
    shareholder_name: 'BNP Paribas Noms Pty Ltd (DRP)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:3,77'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC243',
    shareholder_name: 'Merrill Lynch (Australia) Nominees Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:3,36'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC244',
    shareholder_name:
      'Acuity Capital Investment Management Pty Ltd (Acuity Capital Holdings a/c)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:2,98'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC245',
    shareholder_name: 'US Register Control A/C',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:2,83'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC246',
    shareholder_name:
      'BNP Paribas Nominees Pty Ltd (IB AU Noms Retail Client DRP)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:1,26'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC247',
    shareholder_name:
      'Sydney Business Advisers Pty Ltd (CF Super Fund No 2 A/c)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:1,14'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC248',
    shareholder_name: 'National Nominees Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP35', 'EMP36'],
    companies_id_share_percentage: ['EMP35:1,1', 'EMP36:1,13'],
    companies: 'Lake Resources NL,Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC249',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd ACF Clearstream',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,71'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC250',
    shareholder_name: 'Mr Daniel Ruben Bonafede',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,6'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC251',
    shareholder_name: 'Mr Simon James Kalinowski (RKSK Investment A/C)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,58'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC252',
    shareholder_name: 'Ms Ainsley Ruth Williams',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,53'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC253',
    shareholder_name: 'HSBC Custody Nominees (Australia) Limited – A/C 2',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,52'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC254',
    shareholder_name: 'Mr Andrew Robert Powell (The Pan Family A/C)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,51'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC255',
    shareholder_name: 'Leigh Martin Marine Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,45'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC256',
    shareholder_name: '202 Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,44'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC257',
    shareholder_name: 'Superhero Securities Limited (Client A/C)',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,41'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC258',
    shareholder_name: 'Fluid Investments Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP35'],
    companies_id_share_percentage: ['EMP35:0,37'],
    companies: 'Lake Resources NL',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC259',
    shareholder_name: 'Toronga Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:11,88'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC260',
    shareholder_name: 'ESG Minerals Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:8,3'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC261',
    shareholder_name: 'FNQ Resources Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:7,11'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC262',
    shareholder_name: 'ESG Minerals Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:3,3'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC263',
    shareholder_name: 'S3 Consortium Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:3,11'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC264',
    shareholder_name: 'Shape Wealth Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:2,01'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC265',
    shareholder_name: 'Apertus Capital',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,45'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC266',
    shareholder_name: 'Viking Capital Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,32'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC267',
    shareholder_name: 'Carstairs Resources Pty Ltd ""Carstairs A/C""',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,32'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC268',
    shareholder_name: 'Kelemen Nominees Pty Ltd ""Kyneton Property A/C""',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,21'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC269',
    shareholder_name:
      'Kobala Investments Pty Ltd ""Fernardo Edward Family A/C""',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,19'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC270',
    shareholder_name: 'Wes Capital (PTE) Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,06'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC271',
    shareholder_name: 'Mr Pedro Pereira Fonseca',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,06'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC272',
    shareholder_name: 'Mr Rodrigo Martins Menezes',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:1,06'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC273',
    shareholder_name:
      'Mr Craig Andrew Sharpe+Mrs Michelle Rose Sharpe ""Funky Monkey Super Fund A/C""',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:0,96'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC274',
    shareholder_name: 'Tengirri Pty Ltd ""RHCGS Family A/C""',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:0,92'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC275',
    shareholder_name: 'Lascelles Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:0,81'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC276',
    shareholder_name: 'FMG Resources Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:0,79'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC277',
    shareholder_name: 'Two Tops Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP38', 'EMP70'],
    companies_id_share_percentage: ['EMP38:0,78,EMP70:1,17'],
    companies: 'Lightning Minerals Ltd,Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC278',
    shareholder_name:
      'BNP Paribas Nominees Pty Ltd ""IB Au Noms Retailclient""',
    company_type: '',
    country: '',
    companies_id: ['EMP38'],
    companies_id_share_percentage: ['EMP38:0,76'],
    companies: 'Lightning Minerals Ltd',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC279',
    shareholder_name: 'T. Rowe Price Group Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP39'],
    companies_id_share_percentage: ['EMP39:?'],
    companies: 'Lilac Solutions Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC280',
    shareholder_name: 'General Motors Co.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:9,26'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC281',
    shareholder_name: 'George Ring Ireland Lead Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:2,01'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC282',
    shareholder_name: 'William Blair Investment Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:2'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC283',
    shareholder_name: 'Centerbook Partners LP',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:1,91'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC284',
    shareholder_name: 'Van Eck Associates Corp.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:1,81'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC285',
    shareholder_name: 'John Anthony Kanellitsas Executive Chairman',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:1,39'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC286',
    shareholder_name: 'Franco Mignacco Non-Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:1,32'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC287',
    shareholder_name: 'RWC Partners Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:1,28'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC288',
    shareholder_name: 'Konwave AG (Gold 2000)',
    company_type: '',
    country: '',
    companies_id: ['EMP40', 'EMP44'],
    companies_id_share_percentage: ['EMP40:1,11', 'EMP44:0,21'],
    companies: 'Lithium Argentina AG,Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC289',
    shareholder_name: 'RWC Asset Management LLP',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:?'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC290',
    shareholder_name: 'M&G Investment Management Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,94'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC291',
    shareholder_name: 'Lloyd Harbor Capital Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:?'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC292',
    shareholder_name: 'Tetrem Capital Management Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,39'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC293',
    shareholder_name: 'Commodity Capital AG',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,31'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC294',
    shareholder_name: 'Grupo Minero Los Boros S.A.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,3'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC295',
    shareholder_name: 'Intact Investment Mgmt Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,3'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC296',
    shareholder_name: 'Formidable Asset Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,25'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC297',
    shareholder_name: 'Russell Investment Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:0,22'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC298',
    shareholder_name: 'Ganfeng Lithium Group Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP40'],
    companies_id_share_percentage: ['EMP40:9,26'],
    companies: 'Lithium Argentina AG',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC299',
    shareholder_name: 'Gator Capital Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:18,36'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC300',
    shareholder_name: 'Al Kroontje',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:4,67'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC301',
    shareholder_name: 'Steven Cochrane',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:1,6'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC302',
    shareholder_name: 'Ken Booth',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:0,22'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC303',
    shareholder_name: 'Jana Lillies',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:0,21'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC304',
    shareholder_name: 'Jose Gustavo de Castro Alem',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:0,14'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC305',
    shareholder_name: 'BCM Advisors LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP41'],
    companies_id_share_percentage: ['EMP41:0,01'],
    companies: 'Lithium Chile Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC306',
    shareholder_name: 'LC SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP42'],
    companies_id_share_percentage: ['EMP42:50'],
    companies: 'Lithium Chile SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC307',
    shareholder_name: 'Gino Alfredo Zandonai Steel',
    company_type: '',
    country: '',
    companies_id: ['EMP42'],
    companies_id_share_percentage: ['EMP42:50'],
    companies: 'Lithium Chile SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC308',
    shareholder_name: 'Arena Investors LP',
    company_type: '',
    country: '',
    companies_id: ['EMP43'],
    companies_id_share_percentage: ['EMP43:49,86'],
    companies: 'Lithium Energi Exploration Inc. (LEXI)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC309',
    shareholder_name: 'Triangle Lithium LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP43'],
    companies_id_share_percentage: ['EMP43:12,46'],
    companies: 'Lithium Energi Exploration Inc. (LEXI)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC310',
    shareholder_name: 'James Walker',
    company_type: '',
    country: '',
    companies_id: ['EMP43'],
    companies_id_share_percentage: ['EMP43:2,9'],
    companies: 'Lithium Energi Exploration Inc. (LEXI)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC311',
    shareholder_name: 'Raul Sanabria',
    company_type: '',
    country: '',
    companies_id: ['EMP43'],
    companies_id_share_percentage: ['EMP43:0,29'],
    companies: 'Lithium Energi Exploration Inc. (LEXI)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC312',
    shareholder_name: 'Doublewood Consulting, Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP43'],
    companies_id_share_percentage: ['EMP43:0,13'],
    companies: 'Lithium Energi Exploration Inc. (LEXI)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC313',
    shareholder_name: 'BMO Asset Management Corp.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:5,8'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC314',
    shareholder_name: 'Fourth Sail Capital LP',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:4,81'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC315',
    shareholder_name: 'RBC Global Asset Management Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:2,14'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC316',
    shareholder_name: 'Canada Life Investment Management Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:0,22'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC317',
    shareholder_name: 'ALPS Advisors, Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:0,2'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC318',
    shareholder_name: 'Sprott Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:0,19'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC319',
    shareholder_name: 'IG Investment Management, Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:0,15'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC320',
    shareholder_name: 'G5 Administradora de Recursos Ltda.',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:0,14'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC321',
    shareholder_name: 'Fidelity International Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP44'],
    companies_id_share_percentage: ['EMP44:0,11'],
    companies: 'Lithium Ionic Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC322',
    shareholder_name: 'Adrian Hobkirk',
    company_type: '',
    country: '',
    companies_id: ['EMP45'],
    companies_id_share_percentage: ['EMP45:0,5'],
    companies: 'Lithium South Development Corporation (LIS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC323',
    shareholder_name: 'Christopher Cherry',
    company_type: '',
    country: '',
    companies_id: ['EMP45'],
    companies_id_share_percentage: ['EMP45:0,24'],
    companies: 'Lithium South Development Corporation (LIS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC324',
    shareholder_name: 'Fernando Villarroel Alcocer',
    company_type: '',
    country: '',
    companies_id: ['EMP45'],
    companies_id_share_percentage: ['EMP45:0,07'],
    companies: 'Lithium South Development Corporation (LIS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC325',
    shareholder_name: 'Jan Urata',
    company_type: '',
    country: '',
    companies_id: ['EMP45'],
    companies_id_share_percentage: ['EMP45:0,02'],
    companies: 'Lithium South Development Corporation (LIS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC326',
    shareholder_name: 'Xiao Tian Dai',
    company_type: '',
    country: '',
    companies_id: ['EMP45'],
    companies_id_share_percentage: ['EMP45:0'],
    companies: 'Lithium South Development Corporation (LIS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC327',
    shareholder_name: 'Inversiones Riverdon SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:5'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC328',
    shareholder_name: 'Huasco Llamara SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:9,62'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC329',
    shareholder_name: 'Minera Ignacia SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:6,51'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC330',
    shareholder_name: 'Minergy Chile SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:12'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC331',
    shareholder_name: 'Sabina Minerals SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:7'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC332',
    shareholder_name: 'Sociedad Minera Aspromin SpA',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:4,52'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC333',
    shareholder_name: 'Felipe Santa María Marambio',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:0,131'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC334',
    shareholder_name: 'Alejandro González Spencer',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:0,065'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC335',
    shareholder_name: 'Rodrigo Vallejos Pincheira',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:0,065'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC336',
    shareholder_name: 'Guillermo Santa María Farr',
    company_type: '',
    country: '',
    companies_id: ['EMP46'],
    companies_id_share_percentage: ['EMP46:0,087'],
    companies: 'Llamara Group SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC337',
    shareholder_name: 'M4D Assets Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP47'],
    companies_id_share_percentage: ['EMP47:100'],
    companies: 'M4E Lithium Ltda.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC338',
    shareholder_name: 'Jonas Fernandes de Oliveira',
    company_type: '',
    country: '',
    companies_id: ['EMP48'],
    companies_id_share_percentage: ['EMP48:?'],
    companies: 'Marico Mineracao Ltda',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC339',
    shareholder_name: 'Luseni Soares dos Santos Oliveira',
    company_type: '',
    country: '',
    companies_id: ['EMP48'],
    companies_id_share_percentage: ['EMP48:?'],
    companies: 'Marico Mineracao Ltda',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC340',
    shareholder_name: 'Adjany Fernandes de Oliveira',
    company_type: '',
    country: '',
    companies_id: ['EMP48'],
    companies_id_share_percentage: ['EMP48:?'],
    companies: 'Marico Mineracao Ltda',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC341',
    shareholder_name: 'Hanson & Doremus Investment Management',
    company_type: '',
    country: '',
    companies_id: ['EMP49'],
    companies_id_share_percentage: ['EMP49:0'],
    companies: 'MGX Minerals Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC342',
    shareholder_name: 'Maximilian Sali',
    company_type: '',
    country: '',
    companies_id: ['EMP52'],
    companies_id_share_percentage: ['EMP52:7,17'],
    companies: 'Monumental Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC343',
    shareholder_name: 'Frank Jacobs',
    company_type: '',
    country: '',
    companies_id: ['EMP52'],
    companies_id_share_percentage: ['EMP52:0,03'],
    companies: 'Monumental Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC344',
    shareholder_name: 'Michelle Dececco',
    company_type: '',
    country: '',
    companies_id: ['EMP52'],
    companies_id_share_percentage: ['EMP52:0,02'],
    companies: 'Monumental Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC345',
    shareholder_name: 'Ryan Cheung',
    company_type: '',
    country: '',
    companies_id: ['EMP52'],
    companies_id_share_percentage: ['EMP52:0'],
    companies: 'Monumental Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC346',
    shareholder_name: 'Kristopher Raffle',
    company_type: '',
    country: '',
    companies_id: ['EMP52'],
    companies_id_share_percentage: ['EMP52:0'],
    companies: 'Monumental Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC347',
    shareholder_name: 'Bill Treuen',
    company_type: '',
    country: '',
    companies_id: ['EMP52'],
    companies_id_share_percentage: ['EMP52:0'],
    companies: 'Monumental Energy Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC348',
    shareholder_name: 'Clean Elements Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP53'],
    companies_id_share_percentage: ['EMP53:37,71'],
    companies: 'NOA Lithium Brines Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC349',
    shareholder_name: 'Hernán Miguel Zaballa',
    company_type: '',
    country: '',
    companies_id: ['EMP53'],
    companies_id_share_percentage: ['EMP53:8,57'],
    companies: 'NOA Lithium Brines Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC350',
    shareholder_name: 'Gabriel Marcelo Rubacha',
    company_type: '',
    country: '',
    companies_id: ['EMP53'],
    companies_id_share_percentage: ['EMP53:4,9'],
    companies: 'NOA Lithium Brines Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC351',
    shareholder_name: 'Estanislao Jose Zaballa',
    company_type: '',
    country: '',
    companies_id: ['EMP53'],
    companies_id_share_percentage: ['EMP53:1,01'],
    companies: 'NOA Lithium Brines Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC352',
    shareholder_name: 'John Miniotis',
    company_type: '',
    country: '',
    companies_id: ['EMP53'],
    companies_id_share_percentage: ['EMP53:0,55'],
    companies: 'NOA Lithium Brines Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC353',
    shareholder_name: 'Leeuwin Equity Pty Ltd <Deakin Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:5,55'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC354',
    shareholder_name: 'Gold Leaf Corporate Pty Ltd <Gold Leaf Corporate A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:5,02'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC355',
    shareholder_name: 'Continental Mining Australia Pty Ltd <Continental A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:4,45'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC356',
    shareholder_name:
      'Mr Jerome Gino Vitale + Mrs Molly Clara Vitale <Vital Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:3,36'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC357',
    shareholder_name: 'Aralad Management Pty Ltd <The TRK Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:3,18'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC358',
    shareholder_name: 'Ratdog Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:3,05'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC359',
    shareholder_name: 'J&A (WA) Nominees Pty Ltd <J&A A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:3,03'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC360',
    shareholder_name: 'Woodsouth Asset Management Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:3'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC361',
    shareholder_name: 'BT Lithium Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:2,69'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC362',
    shareholder_name: 'Charlton Wa Pty Ltd <Tinamara Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:2,43'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC363',
    shareholder_name: 'MMH Capital Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:2,21'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC364',
    shareholder_name: 'SMR Nominees Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:2,1'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC365',
    shareholder_name: 'Jet Capital Pty Ltd <The Oscrow Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:2,05'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC366',
    shareholder_name: 'Symorgh Super Pty Ltd <Symorgh Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:1,99'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC367',
    shareholder_name: 'Pyap Park Pty Ltd <PD&BG Schammer S/Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:1,94'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC368',
    shareholder_name: 'Slam Consulting Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:1,89'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC369',
    shareholder_name: 'Sol Sal Investments Pty Ltd <Sol Sal Investment A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:1,84'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC370',
    shareholder_name: 'Jet Capital Pty Ltd The Oscrow Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:1,81'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC371',
    shareholder_name: 'Schammer Pty Ltd <Schammer Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP54'],
    companies_id_share_percentage: ['EMP54:1,5'],
    companies: 'Oceana Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC372',
    shareholder_name: 'Andrew Ian Pumphrey',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:18,91'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC373',
    shareholder_name: 'Mr Shane Douglas Hockley & Mrs Michele Jane Hockley',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,79'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC374',
    shareholder_name: 'Bedivere Holdings Pty Ltd <The Glastonbury A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,4'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC375',
    shareholder_name: 'Mr Afzal Mehmood Chougle',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,31'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC376',
    shareholder_name: 'Sentir Pty Ltd <Revolucion Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,31'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC377',
    shareholder_name: 'Greenhill Road Investments Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,31'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC378',
    shareholder_name:
      'Mr Warrick Geoffrey Cannon & Mrs Lorna Hazel Cannon <Wacklorn Sf A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,31'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC379',
    shareholder_name:
      'Mr Christopher William Chalwell & Mr Ian Wayne Wilson <Chalwell Pension Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,31'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC380',
    shareholder_name: 'Mr Rodney Owen Clifford',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,24'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC381',
    shareholder_name: 'G & C Ashmore Nominees Pty Ltd <Ashmore Superfund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,18'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC382',
    shareholder_name:
      'Mr Adrian Bruce Watt & Mrs Tracey Janine Watt <A & T Watt Family S/F A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:1,09'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC383',
    shareholder_name: 'Hunter Holdings Pty Ltd <The Andrews Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:0,98'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC384',
    shareholder_name: 'Mr Timothy Craig Rice',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:0,95'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC385',
    shareholder_name: 'Mr Phillip Craig Reid',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:0,9'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC386',
    shareholder_name: 'Nobletone Properties Pty Ltd <Harburg Unit A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:0,87'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC387',
    shareholder_name: 'FR8 Solutions Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:0,87'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC388',
    shareholder_name: 'Carroll Corporation Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP55'],
    companies_id_share_percentage: ['EMP55:0,86'],
    companies: 'OzAurum Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC389',
    shareholder_name: 'JP Morgan Nominees Australia Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:19,23'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC390',
    shareholder_name: 'POS-LT Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:2,55'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC391',
    shareholder_name: 'Merrill Lynch (Australia) Nominees Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:1,75'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC392',
    shareholder_name: 'GFL International Co Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:1,05'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC393',
    shareholder_name:
      'HSBC Custody Nominees (Australia) Limited <NT-Comnwlth Super Corp A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,77'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC394',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd <Agency Lending A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,66'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC395',
    shareholder_name: 'Washington H Soul Pattinson and Company Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,54'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC396',
    shareholder_name: 'HSBC Custody Nominees (Australia) Limited -A/C 2',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,46'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC397',
    shareholder_name: 'BNP Paribas Nominees Pty Ltd <HUB24 Custodial Serv Ltd>',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,4'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC398',
    shareholder_name:
      'Merrill Lynch (Australia) Nominees Pty Limited <Equity Finance A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,28'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC399',
    shareholder_name: 'UBS Nominees Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,26'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC400',
    shareholder_name: 'Comsec Nominees Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP36', 'EMP60'],
    companies_id_share_percentage: ['EMP36:0,25', 'EMP60:1,29'],
    companies: 'Pilbara Minerals Ltd (PLS),Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC401',
    shareholder_name: 'Netwealth Investments Limited <Wrap Services A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP36', 'EMP78'],
    companies_id_share_percentage: ['EMP36:0,24', 'EMP78:3,96'],
    companies: 'Pilbara Minerals Ltd (PLS),Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC402',
    shareholder_name: 'HSBC Custody Nominees (Australia) Limited-GSCO ECA',
    company_type: '',
    country: '',
    companies_id: ['EMP36'],
    companies_id_share_percentage: ['EMP36:0,22'],
    companies: 'Pilbara Minerals Ltd (PLS)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC403',
    shareholder_name: 'David Tafel',
    company_type: '',
    country: '',
    companies_id: ['EMP58'],
    companies_id_share_percentage: ['EMP58:2,07'],
    companies: 'Portofino Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC404',
    shareholder_name: 'Jeremy Wright',
    company_type: '',
    country: '',
    companies_id: ['EMP58'],
    companies_id_share_percentage: ['EMP58:1,82'],
    companies: 'Portofino Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC405',
    shareholder_name: 'Stephen Wilkinson',
    company_type: '',
    country: '',
    companies_id: ['EMP58'],
    companies_id_share_percentage: ['EMP58:0,22'],
    companies: 'Portofino Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC406',
    shareholder_name: 'Brian Crawford',
    company_type: '',
    country: '',
    companies_id: ['EMP58'],
    companies_id_share_percentage: ['EMP58:0,14'],
    companies: 'Portofino Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC407',
    shareholder_name: 'National Pension Service',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:8,91'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC408',
    shareholder_name: 'The National Pension Fund',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:8,91'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC409',
    shareholder_name: 'Citigroup Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:4,36'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC410',
    shareholder_name: 'Pohang University of Science and Technology',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:2,62'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC411',
    shareholder_name: 'Samsung Asset Management Company, Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:2,11'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC412',
    shareholder_name: 'Posco Holdings Inc. Employee Stock Ownership Ass',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:1,67'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC413',
    shareholder_name: 'Canada Pension Plan Investment Board',
    company_type: '',
    country: '',
    companies_id: ['EMP59'],
    companies_id_share_percentage: ['EMP59:1,31'],
    companies: 'POSCO Holdings Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC414',
    shareholder_name: 'Fuyang Mingjin New Energy Development Co Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:3,8'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC415',
    shareholder_name: 'Summit Nanotech Corporation',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:3,65'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC416',
    shareholder_name: 'Trade Prestige Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:2,41'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC417',
    shareholder_name: 'Forte Equipment Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:4,2'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC418',
    shareholder_name: 'Golden WorldWide Holdings Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:4,26'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC419',
    shareholder_name: 'Mr Peter Andrew Proksa',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,66'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC420',
    shareholder_name: 'S & N Curtain Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,07'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC421',
    shareholder_name: 'Abaskhiron Services Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,95'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC422',
    shareholder_name: 'Mrs Sandy Tossoun',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,65'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC423',
    shareholder_name: 'Mr Lin Zhu',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:0,82'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC424',
    shareholder_name: 'Melbor Pty Ltd <RJW Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,55'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC425',
    shareholder_name: 'Mr Mena Habib',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:0,88'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC426',
    shareholder_name: 'PN Trading & Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,08'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC427',
    shareholder_name: 'Taylor Four Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,07'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC428',
    shareholder_name: 'Mr Stephen John Curtain',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:1,03'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC429',
    shareholder_name: 'Ms Keng Yoke Lee',
    company_type: '',
    country: '',
    companies_id: ['EMP60'],
    companies_id_share_percentage: ['EMP60:0,99'],
    companies: 'Power Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC430',
    shareholder_name: 'Riya Investments Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP60', 'EMP62'],
    companies_id_share_percentage: ['EMP60:0,86', 'EMP62:11,71'],
    companies: 'Power Minerals Limited,Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC431',
    shareholder_name: 'Argosy Minerals Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP61'],
    companies_id_share_percentage: ['EMP61:77,5'],
    companies: 'Puna Mining S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC432',
    shareholder_name: 'Pablo Alurralde',
    company_type: '',
    country: '',
    companies_id: ['EMP61'],
    companies_id_share_percentage: ['EMP61:?'],
    companies: 'Puna Mining S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC433',
    shareholder_name: 'Delta Capital Investments Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:13,51'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC434',
    shareholder_name: 'Vidog Capital Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP62', 'EMP70'],
    companies_id_share_percentage: ['EMP62:8,47', 'EMP70:2,1'],
    companies: 'Pursuit Minerals Limited,Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC435',
    shareholder_name: 'Yucaja Pty Ltd <The Yoegiar Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:4,41'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC436',
    shareholder_name: 'Time Valuations Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:3,99'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC437',
    shareholder_name: 'Mr Craig Sheldon Rowles',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:3,33'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC438',
    shareholder_name: 'Keema Investments Pty Ltd <Howard Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:3,01'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC439',
    shareholder_name: 'Mr Nicholas Dermott Mcdonald',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:2,16'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC440',
    shareholder_name: 'Muggins Investments Pty Ltd <Muggins Investment Trust>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:2,16'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC441',
    shareholder_name:
      'S3 Consortium Holdings Pty Ltd <Nextinvestors Dot Com A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:2,16'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC442',
    shareholder_name: 'Aukera Capital Pty Ltd <Aukera Discretionary A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,73'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC443',
    shareholder_name:
      'ABN Amro Clearing Sydney Nominees Pty Ltd <Custodian A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,58'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC444',
    shareholder_name: 'RE Capital Advisory Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,49'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC445',
    shareholder_name: 'Tintern (VIC) Pty Ltd <A&P Miller Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,35'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC446',
    shareholder_name: 'Riya Investmentss Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,29'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC447',
    shareholder_name: 'Pheakes Pty Ltd <Senate A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,29'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC448',
    shareholder_name: 'Australasian Auction Solutions Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,29'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC449',
    shareholder_name: 'MR George Burton Hacon <No 2 A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,08'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC450',
    shareholder_name: 'Iamatana Pty Limited <Iamatana A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,08'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC451',
    shareholder_name: 'Australasian Auction Solutions Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,08'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC452',
    shareholder_name: 'Mr Mark Freeman <Mark Freeman Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:1,04'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC453',
    shareholder_name: 'Huic Noms Pty Ltd <Accumulation Entrepot A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:0,93'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC454',
    shareholder_name: 'Mr Wing Kai Li & Ms Pui Man Chan',
    company_type: '',
    country: '',
    companies_id: ['EMP62'],
    companies_id_share_percentage: ['EMP62:0,9'],
    companies: 'Pursuit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC455',
    shareholder_name: 'Aluminum Corporation of China',
    company_type: '',
    country: '',
    companies_id: ['EMP65'],
    companies_id_share_percentage: ['EMP65:11,23'],
    companies: 'Rio Tinto Group',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC456',
    shareholder_name: 'Australian Super Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP65'],
    companies_id_share_percentage: ['EMP65:3,1'],
    companies: 'Rio Tinto Group',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC457',
    shareholder_name: 'Norges Bank Investment Management',
    company_type: '',
    country: '',
    companies_id: ['EMP65', 'EMP67'],
    companies_id_share_percentage: ['EMP65:1,68', 'EMP67:2,24'],
    companies: 'Rio Tinto Group,Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC458',
    shareholder_name: 'Capital Research and Management Company',
    company_type: '',
    country: '',
    companies_id: ['EMP65', 'EMP71'],
    companies_id_share_percentage: ['EMP65:1,59', 'EMP71:?'],
    companies: 'Rio Tinto Group,Stellantis N.V.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC459',
    shareholder_name: 'Fisher Asset Management, LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP65'],
    companies_id_share_percentage: ['EMP65:1,27'],
    companies: 'Rio Tinto Group',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC460',
    shareholder_name: 'JPMorgan Chase & Co.',
    company_type: '',
    country: '',
    companies_id: ['EMP65'],
    companies_id_share_percentage: ['EMP65:1,19'],
    companies: 'Rio Tinto Group',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC461',
    shareholder_name: 'A10 Investimentos Ltda.',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:42,81'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC462',
    shareholder_name: 'BNPP Asset Management Holding',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:3,03'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC463',
    shareholder_name: 'Woodline Partners LP',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:2,66'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC464',
    shareholder_name: 'Citadel Advisors LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:2,16'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC465',
    shareholder_name: 'Rosewill Bay Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:1,51'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC466',
    shareholder_name: 'Damask Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:1,39'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC467',
    shareholder_name: 'Sir Capital Management L.P.',
    company_type: '',
    country: '',
    companies_id: ['EMP67'],
    companies_id_share_percentage: ['EMP67:1,35'],
    companies: 'Sigma Lithium Corporation',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC468',
    shareholder_name: 'Brandon Rook',
    company_type: '',
    country: '',
    companies_id: ['EMP68'],
    companies_id_share_percentage: ['EMP68:6,46'],
    companies: 'Silver Valley Metals Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC469',
    shareholder_name: 'Inversiones TLC SpA (Tianqi Lithium Corporation)',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:21,9'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC470',
    shareholder_name: 'Sociedad de Inversiones Pampa Calichera SA',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:16,31'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC471',
    shareholder_name: 'The Bank of New York Mellon ADRS',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:14,91'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC472',
    shareholder_name: 'Potasios de Chile SA',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:6,36'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC473',
    shareholder_name: 'AFP Habitat',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:3,69'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC474',
    shareholder_name: 'Kochi S.A.',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:0,36'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC475',
    shareholder_name: 'Kowa Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:0,27'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC476',
    shareholder_name: 'Kowa Holdings America Inc.',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:0,08'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC477',
    shareholder_name: 'AFP Provida',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:2,86'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC478',
    shareholder_name: 'AFP Capital',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:2,77'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC479',
    shareholder_name: 'AFP Modelo',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:1,19'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC480',
    shareholder_name: 'AFP Cuprum',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:2,75'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC481',
    shareholder_name: 'Banchile Corredores De Bolsa SA',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:1,26'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC482',
    shareholder_name: 'Banco de Chile por cuenta de Citi Na New York Clie',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:1,71'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC483',
    shareholder_name: 'Bano de Chile por cuenta de State Street',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:3,92'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC484',
    shareholder_name: 'Banco de Chile por cuenta de terceros no residentes',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:1,76'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC485',
    shareholder_name: 'Banco Santander Chile',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:1,13'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC486',
    shareholder_name: 'Banco Santander por cuenta de INV Extranjeros',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:2,73'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC487',
    shareholder_name: 'Global Mining Spa',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:3,08'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC488',
    shareholder_name: 'Inverisones La Esperanza Chile Limitada',
    company_type: '',
    country: '',
    companies_id: ['EMP69'],
    companies_id_share_percentage: ['EMP69:1,49'],
    companies: 'Sociedad Química y Minera de Chile S.A. (SQM)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC489',
    shareholder_name: 'Latin Resources Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:10,24'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC490',
    shareholder_name: 'Mr Darren Carter',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:6,12'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC491',
    shareholder_name: 'Equity Trustees Limited <Lowell Resources Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:4,5'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC492',
    shareholder_name: 'Khe Sahn Pty Ltd <Trading No 1 A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:3,82'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC493',
    shareholder_name: 'Sunset Capital ManagementT Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:2,03'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC494',
    shareholder_name: 'Blue Coasters Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:1,84'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC495',
    shareholder_name: 'Ocean Reef Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:1,76'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC496',
    shareholder_name: 'United Trading Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:1,63'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC497',
    shareholder_name: 'Palm Beach Nominees Pty Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:1,49'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC498',
    shareholder_name: 'Mr Bahram Reazei',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:1,36'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC499',
    shareholder_name: 'Unrandom Pty Ltd <Unrandom A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:1,16'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC500',
    shareholder_name: 'Mandolin Nominees Pty Ltd <TJ Cowcher Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:0,96'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC501',
    shareholder_name: 'Dr Seow Foong Loh',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:0,93'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC502',
    shareholder_name: 'Fairbrother Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:0,84'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC503',
    shareholder_name: 'Mr Nathan Caratti',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:0,76'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC504',
    shareholder_name: 'Chiprock Investments Pty Ltd <Chopie Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:0,76'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC505',
    shareholder_name: 'Dr Leon Eugene Pretorius',
    company_type: '',
    country: '',
    companies_id: ['EMP70'],
    companies_id_share_percentage: ['EMP70:0,76'],
    companies: 'Solis Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC506',
    shareholder_name: 'Exor',
    company_type: '',
    country: '',
    companies_id: ['EMP71'],
    companies_id_share_percentage: ['EMP71:15,52'],
    companies: 'Stellantis N.V.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC507',
    shareholder_name: 'EPF',
    company_type: '',
    country: '',
    companies_id: ['EMP71'],
    companies_id_share_percentage: ['EMP71:7,74'],
    companies: 'Stellantis N.V.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC508',
    shareholder_name: 'BPI',
    company_type: '',
    country: '',
    companies_id: ['EMP71'],
    companies_id_share_percentage: ['EMP71:6,65'],
    companies: 'Stellantis N.V.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC509',
    shareholder_name:
      'Sunset Capital Management Pty Ltd <Sunset Superfund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:7,55'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC510',
    shareholder_name: 'Mrs Sue Balagiannis',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:7,38'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC511',
    shareholder_name: 'Fynaa Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:4,01'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC512',
    shareholder_name: 'Mr Chao Zang',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:3,8'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC513',
    shareholder_name: 'Phekes Pty Ltd <Senate A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:2,21'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC514',
    shareholder_name: 'Carstairs Resources Pty Ltd <Carstairs A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,58'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC515',
    shareholder_name: 'Mr Bryce Matthew Wilson',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,58'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC516',
    shareholder_name: 'Keyano Pty Ltd <Keyano A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,58'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC517',
    shareholder_name: 'Bowden Minerals Pty Ltd <Bowden A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,58'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC518',
    shareholder_name: 'Grande Prairie Trust Pty Ltd <Grande Prairie A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,55'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC519',
    shareholder_name: 'King Corporate Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,51'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC520',
    shareholder_name: 'Crossfield Minerals Pty Ltd <Crossfield A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,47'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC521',
    shareholder_name: 'Mr Sandro Arruda',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,39'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC522',
    shareholder_name: 'Mr Shane Timothy Ball <The Ball A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,21'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC523',
    shareholder_name: 'Breakout Star Holdings Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,12'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC524',
    shareholder_name:
      'Kushkush Investments Pty Ltd <Alexandra Discretionary A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,11'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC525',
    shareholder_name: 'Mr Stephen Gordon Jack',
    company_type: '',
    country: '',
    companies_id: ['EMP72'],
    companies_id_share_percentage: ['EMP72:1,04'],
    companies: 'Summit Minerals Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC526',
    shareholder_name: 'Tecpetrol Internacional S.L.',
    company_type: '',
    country: '',
    companies_id: ['EMP73'],
    companies_id_share_percentage: ['EMP73:95'],
    companies: 'Tecpetrol S.A.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC527',
    shareholder_name: 'China Global New Technology Imp. & Exp. Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:4,91'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC528',
    shareholder_name: 'Sichuan Trust Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:4,76'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC529',
    shareholder_name: 'Sichuan Trust Jinxiu Youzhai No. 1 Collective C',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:4,76'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC530',
    shareholder_name: 'Xinjiang Tacheng International Resources Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:3,07'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC531',
    shareholder_name: 'Hangzhou Changze Trading Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:1,17'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC532',
    shareholder_name: 'China Southern Asset Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:1,15'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC533',
    shareholder_name: 'China Asset Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74', 'EMP81'],
    companies_id_share_percentage: ['EMP74:0,27', 'EMP81:1,22'],
    companies:
      'Tibet Summit Resources Co. Ltd.,Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC534',
    shareholder_name: 'GF Fund Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:0,22'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC535',
    shareholder_name: 'Fullgoal Fund Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP74'],
    companies_id_share_percentage: ['EMP74:0,11'],
    companies: 'Tibet Summit Resources Co. Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC536',
    shareholder_name: 'Toyota Motor Corporation',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:21,7'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC537',
    shareholder_name: 'Toyota Industries Corporation',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:11,19'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC538',
    shareholder_name: 'Nomura Asset Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:4,92'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC539',
    shareholder_name: 'MUFG Bank Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:4,6'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC540',
    shareholder_name: 'Amova Asset Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:2,86'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC541',
    shareholder_name: 'Daiwa Asset Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:2,18'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC542',
    shareholder_name: 'Sumitomo Mitsui Trust Asset Management Co. Lt',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:2,16'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC543',
    shareholder_name: 'Mitsubishi UFJ Asset Management Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP75'],
    companies_id_share_percentage: ['EMP75:1,48'],
    companies: 'Toyota Tsusho Corporation (TTC)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC544',
    shareholder_name: 'Zangge Mining Company Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP77'],
    companies_id_share_percentage: ['EMP77:12,04'],
    companies: 'Ultra Lithium Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC545',
    shareholder_name: 'Kiriaki Smith CFO, Secretary & Director',
    company_type: '',
    country: '',
    companies_id: ['EMP77'],
    companies_id_share_percentage: ['EMP77:0,11'],
    companies: 'Ultra Lithium Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC546',
    shareholder_name: 'Weiguo Lang Chairman & CEO',
    company_type: '',
    country: '',
    companies_id: ['EMP77'],
    companies_id_share_percentage: ['EMP77:6,42'],
    companies: 'Ultra Lithium Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC547',
    shareholder_name: 'Rosatom State Atomiс Energy Corporation',
    company_type: '',
    country: '',
    companies_id: ['EMP91'],
    companies_id_share_percentage: ['EMP91:100'],
    companies: 'Uranium One Group',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC548',
    shareholder_name: 'David Greenway',
    company_type: '',
    country: '',
    companies_id: ['EMP63'],
    companies_id_share_percentage: ['EMP63:6,06'],
    companies: 'Vanguard Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC549',
    shareholder_name: 'Andrew Mugridge',
    company_type: '',
    country: '',
    companies_id: ['EMP63'],
    companies_id_share_percentage: ['EMP63:0,4'],
    companies: 'Vanguard Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC550',
    shareholder_name: 'Bradley Dixon',
    company_type: '',
    country: '',
    companies_id: ['EMP63'],
    companies_id_share_percentage: ['EMP63:0,27'],
    companies: 'Vanguard Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC551',
    shareholder_name: 'Richard Robins',
    company_type: '',
    country: '',
    companies_id: ['EMP63'],
    companies_id_share_percentage: ['EMP63:0,13'],
    companies: 'Vanguard Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC552',
    shareholder_name: 'Lawrence Segerstrom',
    company_type: '',
    country: '',
    companies_id: ['EMP63'],
    companies_id_share_percentage: ['EMP63:0'],
    companies: 'Vanguard Mining Corp.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC553',
    shareholder_name: 'Patrick Volpe & Associated Entities',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:9,08'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC554',
    shareholder_name: 'Foxfire Metals Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:6,72'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC555',
    shareholder_name:
      'Mr Arthur Ioannou & Ms Olivia Keene <Imax Superfund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:2,27'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC556',
    shareholder_name: 'Ms Chunyan Niu',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:1,59'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC557',
    shareholder_name: 'Mr Gavin Jeremy Dunhill',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:1,43'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC558',
    shareholder_name: 'Mr Peter Robert Justin Clarke',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:1,36'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC559',
    shareholder_name: 'MGL Corp Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:1,2'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC560',
    shareholder_name: 'Mr Geoff Kloprogge',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:1,14'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC561',
    shareholder_name: 'Allekian Exchange Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:0,96'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC562',
    shareholder_name: 'Mr Gregory Stephen Cohen',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:0,96'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC563',
    shareholder_name: 'Mr Bin Liu',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:0,93'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC564',
    shareholder_name: 'TPC Consulting Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:0,9'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC565',
    shareholder_name: 'Mr Christopher Ian Switzer',
    company_type: '',
    country: '',
    companies_id: ['EMP78'],
    companies_id_share_percentage: ['EMP78:0,84'],
    companies: 'Verity Resources Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC566',
    shareholder_name: 'David Lies Director',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:6,92'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC567',
    shareholder_name: 'Hendrik van Alphen CEO & Non-Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:1,6'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC568',
    shareholder_name: 'Bosch Management Inc',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,35'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC569',
    shareholder_name: 'Xiaohuan Tang Director',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,12'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC570',
    shareholder_name: 'Sead Hamzagic Chief Financial Officer',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,1'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC571',
    shareholder_name: 'Gordon Kenneth Neal Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,04'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC572',
    shareholder_name: 'Sandhill Capital Partners LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,04'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC573',
    shareholder_name: 'Stefan Schauss Independent Director',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,03'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC574',
    shareholder_name: 'MAI Capital Management LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC575',
    shareholder_name: 'Vermillion & White Wealth Management Group LLC',
    company_type: '',
    country: '',
    companies_id: ['EMP79'],
    companies_id_share_percentage: ['EMP79:0,07'],
    companies: 'Wealth Minerals Ltd.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC576',
    shareholder_name: 'Mr Ruben Gabriel Pindar',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:9,13'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC577',
    shareholder_name: 'Jemaya Pty Ltd <Featherby Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:7,13'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC578',
    shareholder_name: 'Jemaya Pty Ltd <JH Featherby Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:4,34'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC579',
    shareholder_name:
      'Daniel Santos + Juan Manuel Santos + Luz Bollea + Gonzalo A S Bollea',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:3,6'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC580',
    shareholder_name: 'Jemaya Pty Ltd <JH Featherby Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:3,35'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC581',
    shareholder_name:
      'St Barnabas Investments Pty Ltd <The Melvista Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,81'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC582',
    shareholder_name:
      'Morgan Stanley Australia Securities (Nominee) Pty Limited <NO 1 Account>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,42'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC583',
    shareholder_name: 'BNP Paribas Noms Pty Ltd <Global Markets>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,32'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC584',
    shareholder_name: '1000056634 Ontario Inc',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,25'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC585',
    shareholder_name:
      'Baskerville Investments Pty Ltd <Baskerville Family A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,25'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC586',
    shareholder_name:
      'Mr Gregory Rolland Cunnold + Ms Lara Cheryl Groves <Stratford A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,14'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC587',
    shareholder_name: 'Mr John Mosegaard Norup',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:1,06'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC588',
    shareholder_name: 'Bluedale Pty Ltd <Com Super Fund A/C>',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:0,87'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC589',
    shareholder_name: 'Southern Cross Capital Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:0,8'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC590',
    shareholder_name: 'Cen Pty Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:0,77'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC591',
    shareholder_name: 'Agrosucre Global Enterprises Inc',
    company_type: '',
    country: '',
    companies_id: ['EMP80'],
    companies_id_share_percentage: ['EMP80:0,7'],
    companies: 'XTC Lithium Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC592',
    shareholder_name: 'Estado Plurinacional de Bolivia',
    company_type: '',
    country: '',
    companies_id: ['EMP21'],
    companies_id_share_percentage: ['EMP21:100'],
    companies: 'Yacimientos de Litio Bolivianos (YLB)',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC593',
    shareholder_name:
      'Minxi Xinghang State-owned Assets Investment Operation Co. Ltd.',
    company_type: '',
    country: '',
    companies_id: ['EMP81'],
    companies_id_share_percentage: ['EMP81:22,98'],
    companies: 'Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC594',
    shareholder_name: 'China Securities Finance Corporation Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP81'],
    companies_id_share_percentage: ['EMP81:2,61'],
    companies: 'Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC595',
    shareholder_name: 'Perseverance Asset Management L.L.P.',
    company_type: '',
    country: '',
    companies_id: ['EMP81'],
    companies_id_share_percentage: ['EMP81:1,35'],
    companies: 'Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC596',
    shareholder_name: 'GIC Private Limited',
    company_type: '',
    country: '',
    companies_id: ['EMP81'],
    companies_id_share_percentage: ['EMP81:1,11'],
    companies: 'Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC597',
    shareholder_name: 'Invesco Great Wall Fund Management Co. Ltd',
    company_type: '',
    country: '',
    companies_id: ['EMP81'],
    companies_id_share_percentage: ['EMP81:1,07'],
    companies: 'Zijin Mining Group Company Limited',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC598',
    shareholder_name: 'Armando Domingo Araya Ortiz',
    company_type: '',
    country: '',
    companies_id: ['EMP99', 'EMP100'],
    companies_id_share_percentage: ['EMP99:50', 'EMP100:50'],
    companies: 'Inversiones Valeska Minerals SpA,Alto Exploradora SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC599',
    shareholder_name: 'Sandra Ivonne Pérez Lucic',
    company_type: '',
    country: '',
    companies_id: ['EMP99'],
    companies_id_share_percentage: ['EMP99:50'],
    companies: 'Inversiones Valeska Minerals SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC600',
    shareholder_name: 'Armando Esteban Araya Contreras',
    company_type: '',
    country: '',
    companies_id: ['EMP100'],
    companies_id_share_percentage: ['EMP100:50'],
    companies: 'Alto Exploradora SpA',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC601',
    shareholder_name: 'Robert Saltsman',
    company_type: '',
    country: '',
    companies_id: ['EMP102'],
    companies_id_share_percentage: ['EMP102:10,06'],
    companies: 'First Lithium Minerals Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC602',
    shareholder_name: 'Jencorp Inc',
    company_type: '',
    country: '',
    companies_id: ['EMP102'],
    companies_id_share_percentage: ['EMP102:3,94'],
    companies: 'First Lithium Minerals Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC603',
    shareholder_name: 'Peter Espig',
    company_type: '',
    country: '',
    companies_id: ['EMP102'],
    companies_id_share_percentage: ['EMP102:0,56'],
    companies: 'First Lithium Minerals Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC604',
    shareholder_name: 'Gary Schellenberg',
    company_type: '',
    country: '',
    companies_id: ['EMP105'],
    companies_id_share_percentage: ['EMP105:15,04'],
    companies: 'Origen Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC605',
    shareholder_name: 'Geoffrey Schellenberg',
    company_type: '',
    country: '',
    companies_id: ['EMP105'],
    companies_id_share_percentage: ['EMP105:10,53'],
    companies: 'Origen Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC606',
    shareholder_name: 'Paul Chung',
    company_type: '',
    country: '',
    companies_id: ['EMP105'],
    companies_id_share_percentage: ['EMP105:0,69'],
    companies: 'Origen Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
  {
    shareholder_intern_id: 'ACC607',
    shareholder_name: 'Lawrence Cheung',
    company_type: '',
    country: '',
    companies_id: ['EMP105'],
    companies_id_share_percentage: ['EMP105:0'],
    companies: 'Origen Resources Inc.',
    profile: '',
    source_official: '',
    source_3: '',
    spanish_profile: '',
    english_profile: '',
    portuguese_profile: '',
  },
]
